import { computed, Injectable, Signal } from '@angular/core';
import {
  IScanDocumentData,
  IScanDocumentModel,
  IScanIntroData,
  IScanMethodData,
  IScanValidateData,
  IUploadDocumentType,
  TLastScanActions
} from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IScanDocumentState, ScanActions, ScanSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class ScanDocumentStore extends StateAccessService<IScanDocumentState> {
  readonly state$: Observable<IScanDocumentState>;

  readonly data$$: Signal<IScanDocumentData>;
  readonly model$$: Signal<IScanDocumentModel>;
  readonly lastScanAction$$: Signal<TLastScanActions>;
  readonly error$$: Signal<any>;
  readonly isScanRetryAttempt$$: Signal<boolean>;
  readonly selectedDocument$$: Signal<IUploadDocumentType | undefined>;
  readonly notSelectedDocument$$: Signal<IUploadDocumentType | undefined>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(ScanSelectors.scanDocumentStateModel);
    this.data$$ = this.stateFacade.selectSignal$(ScanSelectors.scanDocumentStateData);
    this.lastScanAction$$ = this.stateFacade.selectSignal$(ScanSelectors.lastScanAction);
    this.error$$ = this.stateFacade.selectSignal$(ScanSelectors.scanDocumentStateError);
    this.isScanRetryAttempt$$ = this.stateFacade.selectSignal$(ScanSelectors.isScanRetryAttempt);
    this.selectedDocument$$ = computed(() =>
      this.data$$()?.documents?.find((doc) => doc.docCode === this.model$$().selectedDocId)
    );
    this.notSelectedDocument$$ = computed(() =>
      this.data$$()?.documents?.find((doc) => doc.docCode !== this.model$$().selectedDocId)
    );
  }

  dispatchScanReset() {
    this.stateFacade.dispatch(ScanActions.resetScanDocument());
  }
  dispatchLoadScanDocument(selectedDocId: number) {
    this.stateFacade.dispatch(ScanActions.loadScanDocument({ selectedDocId }));
  }
  dispatchSubmitScanDocumentFailure(error: any) {
    this.stateFacade.dispatch(ScanActions.submitScanDocumentFailure(error));
  }

  dispatchSubmitScanDocument(model: IScanDocumentModel) {
    this.stateFacade.dispatch(ScanActions.submitScanDocument({ model }));
  }

  dispatchSubmitScanDocumentSuccess({ data }: { data: IScanDocumentData }) {
    this.stateFacade.dispatch(ScanActions.submitScanDocumentSuccess({ data }));
  }
  dispatchUpdateLastScanAction(lastScanAction: TLastScanActions) {
    this.stateFacade.dispatch(ScanActions.updateLastScanAction({ lastScanAction }));
  }
  dispatchUpdateMaxAttemptsError(isMaxAttemptsExceeded: boolean) {
    this.stateFacade.dispatch(ScanActions.updateMaxAttemptsError({ isMaxAttemptsExceeded }));
  }

  dispatchLoadScanIntroSuccess({ data }: { data: IScanIntroData }) {
    this.stateFacade.dispatch(ScanActions.loadScanIntroSuccess({ data }));
  }
  dispatchSaveScanValidateData({ data }: { data: IScanValidateData }) {
    this.stateFacade.dispatch(ScanActions.saveScanValidate({ data }));
  }

  dispatchScanValidateFailure(error: any) {
    this.stateFacade.dispatch(ScanActions.scanValidateFailure({ error }));
  }
  dispatchLoadScanMethodSuccess({ data }: { data: IScanMethodData }) {
    this.stateFacade.dispatch(ScanActions.loadScanMethodSuccess({ data }));
  }
  dispatchUploadDocument(model: IScanDocumentModel) {
    this.stateFacade.dispatch(ScanActions.uploadDocument({ model }));
  }
  dispatchUploadDocumentSuccess(data: IScanDocumentData) {
    this.stateFacade.dispatch(ScanActions.uploadDocumentSuccess({ data }));
  }
  dispatchDeleteDocument() {
    this.stateFacade.dispatch(ScanActions.deleteDocument());
  }
  dispatchResetUploadedDocuments() {
    this.stateFacade.dispatch(ScanActions.resetUploadedDocuments());
  }
  dispatchDeleteBackSideDocument() {
    this.stateFacade.dispatch(ScanActions.deleteBackSideDocument());
  }
  dispatchDeleteFrontSideDocument() {
    this.stateFacade.dispatch(ScanActions.deleteFrontSideDocument());
  }
}
